import { decamelizeKeys } from 'humps';
import ReactOnRails from 'react-on-rails';

export default {
  /**
   * Create a medical (HIPAA) release request and send the email with the form link.
   * This hits a non-API JSON controller action, so we include the authenticity token.
   * @param {number} orderId
   * @param {string} state
   * @param {string} parentEmail
   * @returns {Promise<object>} The server JSON response
   */
  create(orderId, state, parentEmail) {
    const authenticityToken = ReactOnRails.authenticityToken();

    return new Promise((resolve, reject) => {
      $.ajax({
        url: '/api/v1/hipaa_release_requests',
        type: 'POST',
        dataType: 'json',
        data: decamelizeKeys({ orderId, state, parentEmail, authenticityToken }),
        success: response => resolve(response),
        error: response => {
          const error = response.responseJSON || response.responseText || 'Request failed';
          reject(error);
        }
      });
    });
  }
};


